<template>
  <transition name="dialog-fade">
    <div
      class="dialog__wrapper"
      v-show="visible"
      @click.self="handleWrapperClick"
    >
      <div :class="{'dialog-default': defaultClazz}">
        <div class="dialog__header">
          <div class="dialog__header__title">
            <slot name="title"></slot>
          </div>
          <OButton
            class="dialog__header__close"
            type="icon"
            size="mini"
            @click="handleClose"
          >
            <i class="xh-icon-close" />
          </OButton>
        </div>
        <div class="dialog__body">
          <slot></slot>
        </div>
        <div
          class="dialog__footer"
          v-if="$slots.footer"
        >
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import OButton from '@/components/Button.vue';

export default {
  name: 'Dialog',

  components: {
    OButton,
  },

  props: {
    visible: {
      type: Boolean,
    },
    defaultClazz: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    handleWrapperClick() {
      this.$emit('wrapper-click');
    },

    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
@padding: 20px;

.dialog {
  &__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    margin: 0;
    background-color: rgba(0, 0, 0, .4);
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-default {
    position: relative;
    min-width: 550px;
    background-color: #fff;
    box-shadow:0px 0px 3px 0px rgba(0,0,0,0.5);
    border-radius: 5px;
  }

  &__header {
    padding: @padding;
    text-align: center;

    &__title {
      font-size: 20px;
      font-weight: 500;
      color: #696560;
    }

    &__close {
      position: absolute;
      top: -15px;
      right: -36px;
    }
  }

  &__body {
    padding: 5px @padding;
    color: #606266;
  }

  &__footer {
    padding: 8px @padding;
    text-align: center;
  }
}

.dialog-fade-enter-active {
  animation: dialog-fade-in .3s;
}

.dialog-fade-leave-active {
  animation: dialog-fade-out .3s;
}

@keyframes dialog-fade-in {
  0% {
    // transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  100% {
    // transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes dialog-fade-out {
  0% {
    // transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    // transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
</style>
